(function () {
  var IP = window.IPSections;
  if (!IP) return;

  var toArray = IP.toArray;
  var markReady = IP.markReady;
  var readFloat = IP.readFloat;

  function initShowcase(section) {
    if (!markReady(section, 'ready')) return;

    var cards = section.querySelectorAll('[data-ip-showcase-card]');
    var grid = section.querySelector('[data-ip-showcase-grid]');
    var previousButton = section.querySelector('[data-ip-showcase-prev]');
    var nextButton = section.querySelector('[data-ip-showcase-next]');

    function syncSectionHeight() {
      section.classList.toggle('has-active-subscription', Boolean(section.querySelector('[data-subscribe-toggle]:checked')));
    }

    function getSlideDistance() {
      if (!grid) return 0;

      var firstCard = grid.querySelector('[data-ip-showcase-card]');

      if (!firstCard) {
        return Math.max(grid.clientWidth, 300);
      }

      var styles = window.getComputedStyle(grid);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;

      return firstCard.getBoundingClientRect().width + gap;
    }

    function updateControls() {
      if (!grid || !previousButton || !nextButton) return;

      var maxScroll = Math.max(grid.scrollWidth - grid.clientWidth, 0);
      var hasOverflow = maxScroll > 4;

      previousButton.disabled = !hasOverflow || grid.scrollLeft <= 4;
      nextButton.disabled = !hasOverflow || grid.scrollLeft >= maxScroll - 4;
    }

    function scrollProducts(direction) {
      if (!grid) return;

      grid.scrollBy({
        left: direction * getSlideDistance(),
        behavior: 'smooth'
      });

      window.setTimeout(updateControls, 280);
    }

    if (previousButton) {
      previousButton.addEventListener('click', function () {
        scrollProducts(-1);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        scrollProducts(1);
      });
    }

    if (grid) {
      grid.addEventListener('scroll', updateControls, { passive: true });
      window.addEventListener('resize', updateControls);
      updateControls();
    }

    toArray(cards).forEach(function (card) {
      var toggle = card.querySelector('[data-subscribe-toggle]');
      var frequencyOptions = card.querySelector('[data-selling-plan-options]');
      var planSelect = card.querySelector('[data-selling-plan-select]');
      var sellingPlanInput = card.querySelector('[data-selling-plan-input]');

      if (!toggle || !planSelect || !sellingPlanInput) return;

      function updateSellingPlan() {
        var usesSubscription = toggle.checked;
        var selectedPlan = planSelect.value;

        if (frequencyOptions) {
          frequencyOptions.hidden = !usesSubscription;
        }

        planSelect.disabled = !usesSubscription;

        sellingPlanInput.disabled = !usesSubscription || !selectedPlan;
        sellingPlanInput.value = usesSubscription && selectedPlan ? selectedPlan : '';

        syncSectionHeight();
      }

      toggle.addEventListener('change', updateSellingPlan);
      planSelect.addEventListener('change', updateSellingPlan);

      updateSellingPlan();
    });
  }
  IP.register('ip-showcase', '[data-ip-showcase]', function (section) {
    initShowcase(section);
    IP.initReveal(section);
  });
})();
